"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveMembersSnapshotSchema = exports.ActiveMembersSnapshotBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
exports.ActiveMembersSnapshotBaseSchema = zod_1.z.object({
    snapshotDate: zod_1.z.coerce.date(), // First day of month (e.g., 2024-01-01)
    membershipType: zod_1.z.string(), // "Full Member", "Associate", etc.
    count: zod_1.z.number(), // Count for this type
    totalCount: zod_1.z.number(), // Total active members (all types)
});
exports.ActiveMembersSnapshotSchema = exports.ActiveMembersSnapshotBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
//# sourceMappingURL=ActiveMembersSnapshot.js.map